import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell, DynamicIconWrapper, Icons } from '@components/common';

import { TComparisonDetails } from '@interfaces/cmModule/cmModule';

import { deltaDescriptionTooltip } from './constants';

import styles from './ConsistencyCheckDetails.module.scss';

interface IColumnsProps {
	date: string;
	isMavenirVendor: boolean;
}

export const getColumns = ({
	date,
	isMavenirVendor,
}: IColumnsProps) => [
	{
		header: 'Parameter',
		accessorKey: 'paramName',
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const paramName = getValue();

			return <AdaptiveTableCell text={paramName} />;
		},
	},
	{
		header: 'Site ID',
		accessorKey: 'siteId',
		isHidden: isMavenirVendor,
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const siteId = getValue();

			return <AdaptiveTableCell text={siteId} />;
		},
	},
	{
		header: 'Node ID',
		accessorKey: 'gnbId',
		isHidden: !isMavenirVendor,
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const gnbId = getValue();

			return <AdaptiveTableCell text={gnbId} />;
		},
	},
	{
		header: 'Cnf ID',
		accessorKey: 'configId',
		isHidden: !isMavenirVendor,
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const configId = getValue();

			return <AdaptiveTableCell text={configId} />;
		},
	},
	{
		header: 'Golden',
		accessorKey: 'parameterValueFirst',
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const parameterValueFirst = getValue();

			return <AdaptiveTableCell text={parameterValueFirst} />;
		},
	},
	{
		header: date,
		accessorKey: 'parameterValueSecond',
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const parameterValueSecond = getValue();

			return <AdaptiveTableCell text={parameterValueSecond} />;
		},
	},
	{
		header: () => {
			return (
				<span className={styles.deltaHeader}>
					Delta
					<DynamicIconWrapper
						icon={Icons.info}
						tooltipLabel={deltaDescriptionTooltip}
					/>
				</span>
			);
		},
		accessorKey: 'delta',
		enableSorting: false,
		cell: ({ getValue }: CellContext<TComparisonDetails, any>) => {
			const delta = getValue();

			return (
				<AdaptiveTableCell
					className={styles.deltaCell}
					text={delta || 'N/A'}
				/>
			);
		},
	},
];
